module.exports = __webpack_public_path__ + "kudos_68.svg?27a57c67a5fcbf1c9afe1d0da67c5b21";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_68.svg
// module id = 170
// module chunks = 0